'use strict'

import router from './router'
import $ from 'jquery'

var timer

var paused = false

var soundArray = []


function starter(environment) {
    var ifIos
    if (environment === 'iosvr' | environment === 'ios') {
        ifIos = true
    }
    else {
        ifIos = false
        var ambient = document.getElementById('ambient')
        ambient.play()
    }

    if (environment === 'iosvr' | environment === 'vr') {
        timer = new Timer(startFishChanging, 5000, ifIos);
    }
    else if (environment === 'normal' | environment === 'ios') {
        timer = new Timer(startFishChanging, 3000, ifIos);

    }

}



function startFishChanging(ifIos) {
    if (!ifIos) {
        startMainAudio()
    }
    var fishImages = document.getElementsByTagName('a-curvedimage');
    startFishMoving(fishImages)
    var counter = 9 // to start after still fishes
    timer = new Timer(runBlueCycle, 10000, fishImages, counter, ifIos);
}

function startMainAudio() {
    var processed = document.getElementById('processed')
    processed.play()
    processed.onended = function() {
        var theStory = document.getElementById('main-audio')
        theStory.play()
    }
}

function startFishMoving(fishImages) {
    var fishImage = document.getElementById('leftrg0');
    fishImage.setAttribute('position', '0 2.5 -5')
    fishImage.setAttribute('animation__opacity', 'property:opacity; to: 1;')
    for (var i = 0; i < fishImages.length; i++) {
        fishImages[i].emit('nowGo')
    }
}


function runBlueCycle(fishImages, counter, ifIos) {
    if (counter === fishImages.length) { //toggle the fish cycle stage and set a delay on the paper stage once the counter rises to the number of fishes                      
        counter = 0
        clearTimeout(timer);
        timer = new Timer(runPaperCycle, 100000, fishImages, counter, ifIos)
        //100000, changed from 105000
    }
    else {
        if (!ifIos) {
            if (counter === 15) {
                playWhalesAndCello()
            }

        }
        var fishImage = document.getElementById(fishImages[counter].id);
        var fishKind = fishImage.getAttribute("dataKind");
        if (fishKind != 'still') {
            fishImage.setAttribute('animation__opacity', 'property:opacity; to: 1;')
        }
        clearTimeout(timer);
        counter++
        timer = new Timer(runBlueCycle, 3500, fishImages, counter, ifIos)
        //2500
    }
}


function runPaperCycle(fishImages, counter, ifIos) {
    if (counter === fishImages.length) {
        endCycle(fishImages, ifIos)
    }
    else {
        var fishImage = document.getElementById(fishImages[counter].id);
        makePaperFish(fishImage)
        clearTimeout(timer);
        counter++
        timer = new Timer(runPaperCycle, 200, fishImages, counter)
    }
}



function makePaperFish(fishImage) {
    var newfishImage = fishImage.getAttribute("dataPaper")
    fishImage.setAttribute('animation__fadeOut', 'property: opacity; to: 0;dur:400;');
    fishImage.addEventListener('animationcomplete', function() {
        fishImage.setAttribute('src', newfishImage);
        fishImage.setAttribute('animation__fadeIn', 'property: opacity; to: 1;dur:600;');
    })
}

function stopButton() {
    clearTimeout(timer);
    paused = false
    soundArray = []
    var theSounds = document.getElementsByTagName('audio');
    for (var i = 0; i < theSounds.length; i++) {
        theSounds[i].pause()
        theSounds[i].currentTime = 0
    }
}



function pauseButton() {
    var fishImages = document.getElementsByTagName('a-curvedimage');
    var theSky = document.getElementsByTagName('a-sky')[0];
    var theSounds = document.getElementsByTagName('audio');
    var pauseIcon = document.getElementById('pauseIcon');

    if (!paused) {
        timer.pause()
        for (var i = 0; i < theSounds.length; i++) {
            if (!theSounds[i].paused && !theSounds[i].ended && 0 < theSounds[i].currentTime) {
                theSounds[i].pause();
                soundArray.push(theSounds[i])
            }
        }
        if (pauseIcon) {
        pauseIcon.innerHTML = 'play_circle_filled'
    }
        for (i = 9; i < fishImages.length; i++) {
            fishImages[i].emit('nowPause')
        }

        theSky.emit('nowPause')
    }
    else {
        timer.resume()
        for (i = 0; i < soundArray.length; i++) {
            soundArray[i].play();
        }
        soundArray = []
        if (pauseIcon) {

        pauseIcon.innerHTML = 'pause_circle_filled'
}
        for (i = 9; i < fishImages.length; i++) {
            fishImages[i].emit('nowResume')
        }
        theSky.emit('nowResume')
    }
    paused = !paused
}



function playWhalesAndCello() {
    var whales = document.getElementById('whales')
    var cello = document.getElementById('cello')
    cello.volume = 0
    cello.play()
    whales.volume = 0
    whales.play()
    $('#whales').animate({ volume: 0.2 }, 10000)
    $('#cello').animate({ volume: 0.2 }, 10000)
}

function quietWhalesAndCello() {
    var whales = document.getElementById('whales')
    var cello = document.getElementById('cello')
    var ambient = document.getElementById('ambient')
    $('#cello').animate({ volume: 0 }, 3000, function() {
        cello.pause()
    })

    $('#whales').animate({ volume: 0 }, 3000, function() {
        whales.pause()
    })
    $('#ambient').animate({ volume: 0 }, 7000, function() {
        ambient.pause()
    })
}


function playPaperSounds() {
    var paper = document.getElementById('paper')
    paper.volume = 0
    paper.play()
    $('#paper').animate({ volume: 0.4 }, 3000)
}

function turnToPaperTheme(theSky) {
    theSky.setAttribute('animation', 'property:color;dur:2000;to:#F7F4DD;pauseEvents: nowPause; resumeEvents: nowResume;')


    if (router.currentRoute.path !== '/vr') {
    var materialIcons = document.getElementsByClassName('material-icons');
    for (var i = 0; i < materialIcons.length; i++) {
        materialIcons[i].classList.remove('cyan-text', 'text-accent-2')
        materialIcons[i].classList.add('black-text')
    }
   document.getElementById('timing').style.color = 'black'
   // document.getElementById('fish-progress').style.backgroundColor = 'white!important'
   //  document.getElementById('fish-progress-bar').style.backgroundColor = 'black!important'
    document.getElementById('captions').style.backgroundColor = 'black!important'
    document.getElementById('captions').style.color = 'white!important'

    }
}


function endCycle(fishImages, ifIos) {
    var theSky = document.getElementsByTagName('a-sky')[0]
      turnToPaperTheme(theSky)
    clearTimeout(timer);
    var main
    if (!ifIos) {
        quietWhalesAndCello()
        playPaperSounds()
        main = document.getElementById("main-audio");
    }
    else {
        main = document.getElementById("long-audio");
    }
    
    main.onended = function() {
        theSky.setAttribute('animation__theEnd', 'property:color;delay: 5000;dur:7000;to:#ffffff;easing: easeOutSine;pauseEvents: nowPause; resumeEvents: nowResume;');

        theSky.addEventListener('animationbegin', function() {
            fadeOutFish(fishImages)
            $('#paper').animate({ volume: 0.5 }, 3000, function() {
           $('#paper').animate({ volume: 0 }, 3000)
                })


   if (ifIos) {
               theSky.addEventListener('animationcomplete__theEnd', function() {
        router.push({name: 'home', params: {access: 'given'}})
            })
   }

   else {
    var processed = document.getElementById('processed')
            processed.play()
            processed.onended = function() { router.push({name: 'home', params: {access: 'given'}}) }
        
   }
            })


      

    }

}


function fadeOutFish(fishImages) {
     for (var i = 0; i < fishImages.length; i++) {
            var fishImage = document.getElementById(fishImages[i].id);
            fishImage.setAttribute('animation__finalopacity', 'property:opacity; to: 0; dur: 5000;easing: easeOutSine;pauseEvents: nowPause; resumeEvents: nowResume;');
        }

    if (router.currentRoute.path !== '/vr') {
    var theButtons  = document.getElementById('nav-buttons')
    theButtons.style.opacity = 0
    }

}






// Set the name of the hidden property and the change event for visibility
var hidden, visibilityChange;
if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support 
    hidden = "hidden";
    visibilityChange = "visibilitychange";
}
else if (typeof document.msHidden !== "undefined") {
    hidden = "msHidden";
    visibilityChange = "msvisibilitychange";
}
else if (typeof document.webkitHidden !== "undefined") {
    hidden = "webkitHidden";
    visibilityChange = "webkitvisibilitychange";
}


// If the page is hidden, pause the video;
// if the page is shown, play the video
    
function handleVisibilityChange() {
    if (document[hidden]) {

if ( typeof timer !== 'undefined' && router.currentRoute.path !== '/vr') {
    // the variable is defined

        if (paused === false) {
             pauseButton()
        }
    }
    }
}

// Warn if the browser doesn't support addEventListener or the Page Visibility API
if (typeof document.addEventListener === "undefined" || typeof document[hidden] === "undefined") {
    // console.log("This page requires a browser, such as Google Chrome or Firefox, that supports the Page Visibility API.");
}
else {
    // Handle page visibility change   
    document.addEventListener(visibilityChange, handleVisibilityChange, false);

}


function Timer(callback, delay, param1, param2, param3) {
    var timerId, start;
    var remaining = delay;
    this.pause = function() {
        window.clearTimeout(timerId);
        remaining -= new Date() - start;
        // console.log('timer is pausing')
    };

    this.resume = function() {
        start = new Date();
        window.clearTimeout(timerId);
        timerId = window.setTimeout(callback, remaining, param1, param2, param3);

    };

    this.resume();

}


export { starter, pauseButton, stopButton }
